module.exports = __webpack_public_path__ + "static/media/logo2.ee461927.png";


//////////////////
// WEBPACK FOOTER
// ./src/themes/prior/logo2.png
// module id = 2543
// module chunks = 0